import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-filter-chip',
  templateUrl: './search-filter-chip.component.html',
  styleUrl: './search-filter-chip.component.scss',
})
export class SearchFilterChipComponent {
  @Input() name!: string;
  @Input() options!: { label: string; value: string }[];

  @Output() emitFilter = new EventEmitter<any>();

  selectedOption: { label: string; value: string } | null = null;

  onSelectionChange(event: any) {
    this.selectedOption =
      this.options.find((option) => option.value === event.value) || null;

    this.emitFilter.emit(this.selectedOption?.value);
  }

  clearSelectedOption() {
    this.selectedOption = null;
    this.emitFilter.emit(this.selectedOption);
  }
}
